import { useEffect, useState, useMemo } from 'react';
import getScreenType from './getScreenType';
const useScreenType = (screenTypeConfig) => {
    const curriedGetScreenType = useMemo(() => getScreenType(screenTypeConfig), [screenTypeConfig]);
    const [screenType, setScreenType] = useState(curriedGetScreenType(window.innerWidth));
    useEffect(() => {
        const handleResize = () => {
            setScreenType(curriedGetScreenType(window.innerWidth));
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [curriedGetScreenType]);
    return screenType;
};
export default useScreenType;
//# sourceMappingURL=index.js.map